<ion-button
  #button
  [fill]="this.selected ? 'solid' : 'outline'"
  [strong]="this.strong"
  [shape]="this.shape"
  [size]="this.size"
  (click)="change()"
>
  <ng-content></ng-content>
</ion-button>
